import {
  AmbassadorDesktopHeroOrganism,
  AmbassadorPositiveVisionOrganism,
  AmbassadorDesktopLookingInfluenceOrganism,
  AmbassadorForYouOrganism,
  AmbassadorDoctorSliderOrganism,
  PartnerFormOrganism,
} from '../../organisms/';
import { FooterDesktopTemplate } from '../footer-desktop';
import React from 'react';

export const AmbassadorDesktopTemplate = () => {
  return (
    <>
      <section className="max-w-screen-lg w-4/5 mx-auto bg-waldo-dirty-white">
        <AmbassadorDesktopHeroOrganism />
        <AmbassadorPositiveVisionOrganism />
        <AmbassadorForYouOrganism />
        <AmbassadorDesktopLookingInfluenceOrganism />
      </section>
      <section className="max-w-screen-xl w-11/12 mx-auto bg-waldo-dirty-white">
        <AmbassadorDoctorSliderOrganism
          image1="desktop/woman_doctor.png"
          image2="desktop/male_doctor.png"
          mainImage="desktop/main_doctor.png"
          image3="desktop/young_man_doctor.png"
          image4="desktop/young_woman_doctor.png"
        />
      </section>
      <PartnerFormOrganism title="Contact" buttonLabel="BECOME AN AMBASSADOR" />
      <FooterDesktopTemplate />
    </>
  );
};
